const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  911: {
    path: "/vehicleDamage",
    name: "vehicleDamage",
    meta: {
      title: "车损报价单",
      authId: "911",
      parentId: "1",
      cache: false
    }
  },
  91101: {
    path: "/vehicleDamageTabList",
    // path: "/vehicleDamageList",
    // name: "vehicleDamageList",
    name: "vehicleDamageTabList",
    meta: {
      title: "车损报价单",
      authId: "91101",
      parentId: "911",
      cache: false
    },
    auth: [
      {
        authId: "9110101",
        parentId: "91101",
        label: "查看",
        handle: "handleDetail"
      },
      {
        authId: "9110102",
        parentId: "91101",
        label: "详情",
        handle: "handleDetail"
      },
      {
        authId: "9110103",
        parentId: "91101",
        label: "打印",
        handle: "handlePrint",
        ruleObj: {
          attr: "mode",
          rule: {
            0: "打印",
            1: "打印"
          },
          disabledStatusList: [1]
        }
      }
    ],
    component: _import("vehicleDamage/vehicleDamageList")
  }
}
